import { useTranslation } from 'react-i18next';

import { useAuthorize } from '~features/authentication';
import { NfcTagsDataGrid } from '~features/nfc';
import NfcTagsOverviewContainer from '~features/nfc/containers/nfcTagsOverviewContainer';

import Page from '../page';

const NfcTagsPage = () => {
	const { t } = useTranslation();
	const { isSuperAdmin } = useAuthorize();

	return (
		<Page title={t('nfcTags')}>
			<NfcTagsOverviewContainer enableCreate={isSuperAdmin()} enableDelete />
		</Page>
	);
};

export default NfcTagsPage;
